import { useLazyQuery } from '@apollo/client';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';
import { QUERY_CHECK_LANDLORD_EXIST, QUERY_CEHCK_AGENT_USER_EXITS } from './queries';

export const useCheckLandlordExist = ({ type, value, onCompleted }) => {
  const { t } = useTranslation();

  const [queryCheckLandlordExist, { loading }] = useLazyQuery(QUERY_CHECK_LANDLORD_EXIST, {
    variables: { type, value },
    onCompleted,
    fetchPolicy: 'no-cache',
    onError: e => {
      if (e && e.toString().includes('INVALID_EMAIL')) {
        message.error(t('landlord.auth.login.format_error.username'));
      } else {
        message.error(t('sorry_an_error_occurred_please_try_again'));
      }
    },
  });

  return [queryCheckLandlordExist, loading];
};

export const checkAgentUserExist = ({ type, value, onCompleted }) => {
  const [queryCheckAgentUser, { loading }] = useLazyQuery(QUERY_CEHCK_AGENT_USER_EXITS, {
    variables: { type, value },
    onCompleted,
    fetchPolicy: 'no-cache',
    onError: () => {},
  });
  return [queryCheckAgentUser, loading];
};
